import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=65996e8f&scoped=true"
import script from "./DataTable.js?vue&type=script&lang=js&external"
export * from "./DataTable.js?vue&type=script&lang=js&external"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=65996e8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65996e8f",
  null
  
)

export default component.exports